// extracted by mini-css-extract-plugin
export default {"container":"q3SWWFC2bPOamjrx8eMM"};